import React from 'react';
import { Link } from 'react-router-dom';
import * as Context from 'fw/system/Context'

const hrefPatterns = {
    "vob": "/connectToVOB/{id}",
    "vobOwned": "/manageCompany/{parentId}",
    "sponsor": "/ConnectToSponsors/{id}"
}

const types = {
    "vob": "Company",
    "sponsor": "Corporate Member",
}

class CertificationResult extends React.Component {

    render() {
        var certifications = Context.get("userCertifications");

        const r = this.props.result;

        try {
            var href = hrefPatterns[r.type].replace("{id}", r.id).replace("{parentId}", r.parentId);

            if (r.type === "vob" && certifications.includes(r.id))
                href = hrefPatterns["vobOwned"].replace("{id}", r.id).replace("{parentId}", r.parentId);

            const type = types[r.type];

            return (
                <React.Fragment>
                    <div className="search-result">
                        <Link className="search-link" to={href}>{r.title}</Link><br />
                        <span className="search-type">{type}</span><br />
                        <span className="search-summary" dangerouslySetInnerHTML={{ __html: r.summary }} />
                    </div>
                </React.Fragment>
            )
        }
        catch (e) {
            return null;
        }
    }
}

export default CertificationResult;



// WEBPACK FOOTER //
// ./src/areas/main/search/CertificationResult.js